import { render, staticRenderFns } from "./UpdateCustomerPicAddress.vue?vue&type=template&id=f0b152ae&scoped=true"
import script from "./UpdateCustomerPicAddress.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerPicAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b152ae",
  null
  
)

export default component.exports